/* widerruf.js — Modal-Steuerung + Validierung + AJAX-Versand ueber /contact (Shopify Contact Form) */
(function () {
  /* i18n: Strings aus den Shopify-Sprachdateien (siehe theme.liquid) */
  var wrfT = window.mfyT || function (k, fb) { return fb; };

  var modal = document.getElementById('wrf-modal');
  if (!modal) return;

  var dialog  = modal.querySelector('.wrf__dialog');
  var form    = modal.querySelector('[data-wrf-form]');
  var success = modal.querySelector('[data-wrf-success]');
  var submit  = form ? form.querySelector('.wrf__submit') : null;
  var lastFocus = null;

  function open() {
    lastFocus = document.activeElement;
    modal.hidden = false;
    document.body.classList.add('wrf-lock');
    requestAnimationFrame(function () { modal.classList.add('is-open'); });
    setTimeout(function () {
      var f = form && !form.hidden ? form.querySelector('input, textarea') : dialog.querySelector('[data-wrf-close]');
      if (f) f.focus();
    }, 320);
  }

  function close() {
    modal.classList.remove('is-open');
    document.body.classList.remove('wrf-lock');
    setTimeout(function () {
      modal.hidden = true;
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }, 300);
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-wrf-open]')) { e.preventDefault(); open(); return; }
    if (e.target.closest('[data-wrf-close]')) { e.preventDefault(); close(); }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && !modal.hidden) close();
    if (e.key === 'Tab' && !modal.hidden) trap(e);
  });

  function trap(e) {
    var items = dialog.querySelectorAll('a[href], button:not([disabled]), input, textarea, select');
    if (!items.length) return;
    var first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  }

  if (!form) return;

  function fieldOf(el) { return el.closest('.wrf__field'); }
  function errOf(el) { var f = fieldOf(el); return f ? f.querySelector('[data-wrf-err]') : null; }

  function validate(el) {
    var f = fieldOf(el), err = errOf(el), val = (el.value || '').trim(), msg = '';
    if (!val) {
      msg = wrfT('wrf_required', 'bitte ausfüllen.');
    } else if (el.type === 'email' && !/^[^\s@]+@[^\s@]+\.[a-z]{2,}$/i.test(val)) {
      msg = wrfT('wrf_email', 'bitte gib eine gültige e-mail-adresse ein.');
    } else if (el.id === 'wrf-grund' && val.length < 5) {
      msg = 'bitte beschreibe deinen grund kurz.';
    }
    if (f) f.classList.toggle('has-error', !!msg);
    if (err) err.textContent = msg;
    return !msg;
  }

  var fields = form.querySelectorAll('input[required], textarea[required]');
  Array.prototype.forEach.call(fields, function (el) {
    el.addEventListener('blur', function () { validate(el); });
    el.addEventListener('input', function () {
      if (fieldOf(el) && fieldOf(el).classList.contains('has-error')) validate(el);
    });
  });

  form.addEventListener('submit', function (e) {
    e.preventDefault();
    var ok = true, firstBad = null;
    Array.prototype.forEach.call(fields, function (el) {
      if (!validate(el)) { ok = false; if (!firstBad) firstBad = el; }
    });
    if (!ok) { if (firstBad) firstBad.focus(); return; }

    submit.disabled = true;
    submit.textContent = wrfT('wrf_sending', 'wird gesendet …');

    fetch('/contact', {
      method: 'POST',
      body: new FormData(form),
      headers: { 'X-Requested-With': 'XMLHttpRequest' }
    })
      .then(function (r) {
        if (!r.ok) throw new Error('http ' + r.status);
        return r.text();
      })
      .then(function () {
        form.hidden = true;
        success.hidden = false;
        dialog.querySelector('.wrf__head').hidden = true;
      })
      .catch(function () {
        submit.disabled = false;
        submit.textContent = wrfT('wrf_submit', 'widerruf absenden');
        var f = fieldOf(form.querySelector('#wrf-grund'));
        var err = errOf(form.querySelector('#wrf-grund'));
        if (f && err) {
          f.classList.add('has-error');
          err.textContent = wrfT('wrf_error', 'versand fehlgeschlagen. bitte erneut versuchen oder schreib uns an info@magazinforyou.de.');
        }
      });
  });
})();
